import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import React from 'react';
import ExpectedLogo from '@/assets/logos/expected-full.svg?react';

interface PublicHeaderProps extends React.HTMLAttributes<HTMLElement> {
  logo?: React.ReactNode;
  navLinks?: Array<{
    label: string;
    href: string;
  }>;
}

export function PublicHeader({
  logo,
  navLinks = [
    { label: 'Contact Us', href: 'https://expectedhealthcare.com/contact-us' },
  ],
  className,
  ...props
}: PublicHeaderProps) {
  return (
    <header
      className={cn(
        'sticky top-0 z-50 flex items-center justify-between px-4 md:px-8 py-5 border-b bg-white',
        className
      )}
      {...props}
    >
      <div className="flex items-center">
        {logo || (
          <Link to="/" className="flex items-center">
            {/* Replace with your actual logo */}
            <ExpectedLogo />
          </Link>
        )}
      </div>

      <nav className="flex items-center gap-1">
        {navLinks.map(link => (
          <Link
            key={link.href}
            to={link.href}
            target="_blank"
            className="text-caption-label px-3 py-1"
          >
            {link.label}
          </Link>
        ))}
      </nav>
    </header>
  );
}
